<template>
  <div class="text-center">
    <v-dialog v-model="show" persistent width="300">
      <v-card dark class="loading-modal">
        <v-card-text>
          <v-progress-linear indeterminate color="light-blue" class="mb-0" height="20"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    show: Boolean
  },
};
</script>
<style scoped>
.loading-modal {
      padding-top: 20px;
}
</style>